import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableNonMemberPhoneNumberRequired',
  initialState: true,
  reducers: {
    setEnableNonMemberPhoneNumberRequired(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableNonMemberPhoneNumberRequired } = slice.actions;

export default slice.reducer;
